

import React, { useEffect, useMemo, useState, useRef, useCallback } from 'react';
import {
  Box,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
  Stack,
  Button,
  Divider,
  Chip,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Collapse,
  Popover,
  ButtonBase,
  Switch,
  Checkbox,
  Menu,
  MenuItem,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// --- ICONS ---
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {
  GMailIcon,
  RestoreIconNew,
  WhatsAppIcon,
} from '../../components/SvgIcon/SvgIcon';
import { WhatsappShareButton } from 'react-share';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { API_URL } from '../../config/apiUrl';
import { VariableSizeList as List } from 'react-window';
import CustomDateRangePicker from '../../common/datePicker/Daterangepicker';
import dayjs from 'dayjs';
import { openSnackbar } from '../../redux/actions/snackbarAction';
import StartTime from '@mui/icons-material/AccessTime';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import PhotoIcon from '@mui/icons-material/PhotoFilter';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { isMobile, isTablet } from 'react-device-detect';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import { ROUTES } from '../../routes';
import deletedrecordsfound from '../../assets/images/deletedrecordsfound.png';
import {
  SwipeableList,
  SwipeableListItem,
  SwipeAction,
  TrailingActions,
  Type as ListType,
} from 'react-swipeable-list';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
const MIN_ROW_WIDTH = 932;
// --- DATA PROCESSING UTILITY ---
const groupMeetings = data => {
  const groups = data.reduce((acc, meeting) => {
    const key = meeting.dateLabel;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(meeting);
    return acc;
  }, {});

  const sortedKeys = Object.keys(groups).sort((a, b) => {
    const getDate = str => {
      const label = str.split(', ')[0];
      const datePart = str.split(', ')[1];
      const [day, month, year] = datePart.split('/').map(Number);
      return {
        label,
        date: new Date(2000 + year, month - 1, day),
      };
    };

    const aData = getDate(a);
    const bData = getDate(b);

    const getPriority = label => {
      if (label === 'Today') return 1;
      if (label === 'Yesterday') return 2;
      return 3;
    };

    const aPriority = getPriority(aData.label);
    const bPriority = getPriority(bData.label);

    if (aPriority !== bPriority) return aPriority - bPriority;
    return bData.date - aData.date;
  });

  return sortedKeys.map(key => ({
    dateLabel: key,
    meetings: groups[key],
  }));
};

// ---MeetingItem ---
const MeetingItem = ({
  meeting,
  handlePermanentDelete,
  handleRestore,
  props,
  setLoading,
  setDetails,
  navigate,
  dispatch,
  meetingHistoryData,
  isSelected,
  onSelectChange,
  swipedItemId, 
  setSwipedItemId,
  showCheckbox = false,
  setTriggerMeetingHistoryCall,
  onLongPress,
}) => {

  const isMobileView = isMobile || isTablet;
  
  // Long-press handler state
  const longPressTimerRef = useRef(null);
  const touchStartTimeRef = useRef(null);
  
  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (longPressTimerRef.current) {
        clearTimeout(longPressTimerRef.current);
      }
    };
  }, []);
  
  // Handler for Restore button
  const handleRestoreClick = (event) => {
    event?.stopPropagation?.();
    setOpenRestoreDialogue(true);
  };

  // Handler for Delete button (permanent delete)
  const handleDeleteClick = (event) => {
    event?.stopPropagation?.();
    setOpenDeleteDialogue(true);
  };

  const trailingActions = (
    <TrailingActions>
      <SwipeAction
        destructive={true}
        onClick={handleRestoreClick}
      >
        <Box
          sx={{
            width: '80px',
            height: '100%',
            bgcolor: 'primary.main',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <RestoreIconNew sx={{ fontSize: 24, mb: 0.5 }} />
          <Typography variant="caption" fontWeight={700}>Restore</Typography>
        </Box>
      </SwipeAction>
      <SwipeAction
        destructive={true}
        onClick={handleDeleteClick}
      >
        <Box
          sx={{
            width: '80px',
            height: '100%',
            bgcolor: 'error.main',
            color: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
        >
          <DeleteOutlineIcon sx={{ fontSize: 24, mb: 0.5 }} />
          <Typography variant="caption" fontWeight={700}>Delete</Typography>
        </Box>
      </SwipeAction>

    </TrailingActions>
  );

    const swipeKey = swipedItemId === meeting.id ? 'open' : 'reset';
  const [hoverDisplay, setHoverDisplay] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDeleteDialogue, setOpenDeleteDialogue] = useState(false);
  const [openRestoreDialogue, setOpenRestoreDialogue] = useState(false);

  const handleShareClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [popoverAnchor, setPopoverAnchor] = useState(null);
  const [childMeetingDetails, setChildMeetingDetails] = useState({});

  const handlePopoverOpen = (event, meetingDetails) => {
    setChildMeetingDetails(meetingDetails);
    setPopoverAnchor(event.currentTarget);
  };

  const handlePopoverClose = event => {
    event.stopPropagation();
    setChildMeetingDetails({});
    setPopoverAnchor(null);
  };
  const open = Boolean(popoverAnchor);


  const shareUrl = 'http://172.16.0.217:8142/history';
  const subject = encodeURIComponent('Check this out!');
  const body = encodeURIComponent(`Hey, take a look at this:\n\n${shareUrl}`);
  const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&su=${subject}&body=${body}`;
  const commonStyles = {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      textAlign: 'left',
      minWidth: 0, // Critical for text truncation in flex
    };
  const ClickableWrapper = ({ children }) => (


    <ButtonBase
      onClick={() => {
        setLoading(true);
        setDetails({
          meetingDetails: meeting,
          includeDeleted: true,
          isResume: false,
          isDetailsView: true,
        });
        navigate(ROUTES.BIN_MEETING(meeting.id));
      }}
      sx={commonStyles}
    >
      {children}
    </ButtonBase>
  );

  const parentDetialsDisplay = () => {
    var parentDetails = {};
    if (childMeetingDetails.hasInfo) {
      var details = meetingHistoryData.apiData.find(
        data => data.id === childMeetingDetails.parentRecordingId
      );
      if (details && Object.keys(details).length > 0) {
        parentDetails = { ...details };
      } else {
        setChildMeetingDetails({});
        setPopoverAnchor(null);
        dispatch(
          openSnackbar(
            'warning',
            'Parent meeting details not found. Either meeting was deleted or not found in the selected date range.'
          )
        );
        return;
      }
    }

    return (
      <Popover
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        onClose={handlePopoverClose}
        onClick={e => {
          e.stopPropagation();
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disableRestoreFocus
        slotProps={{
          paper: {
            sx: {
              width: 210,
            },
          },
        }}
      >
        {parentDetails && Object.keys(parentDetails).length > 0 && (
          <Box py={1} px={1.5}>
            <Box>
              <Typography variant="caption" color="grey.400">
                Meeting Title
              </Typography>
              <Tooltip title={parentDetails.title} arrow>
                <Typography
                  variant="body2"
                  component="div"
                  noWrap
                  fontWeight={500}
                  color="secondary.main"
                >
                  {parentDetails.title}
                </Typography>
              </Tooltip>
            </Box>

            <Box display={'flex'} alignItems={'center'} gap={2}>
              <Box>
                <Typography variant="caption" color="grey.400">
                  Duration
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color="text.primary"
                >
                  {parentDetails.duration}
                </Typography>
              </Box>

              <Box>
                <Typography variant="caption" color="grey.400">
                  Start Time
                </Typography>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  color="text.primary"
                >
                  {parentDetails.startTime}
                </Typography>
              </Box>
            </Box>

            <Box>
              <Typography variant="caption" color="text.secondary">
                Date
              </Typography>
              <Typography variant="body2" fontWeight={500} color="text.primary">
                {parentDetails.dateLabel}
              </Typography>
            </Box>
          </Box>
        )}
      </Popover>
    );
  };

  return (
    <>
     {!isMobileView && (
      <Paper
        sx={{
          // px: 2,
          backgroundColor: 'var(--grey-0)',
          borderRadius: 0,
              padding:'0px',
        }}
        elevation={0}
      >
        <Stack
          direction="row"
          alignItems="center"
           sx={{
            width: '100%',
            minWidth: `${MIN_ROW_WIDTH}px`,
            height: '60px',
            gap: 0,
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
            justifyContent: 'start',
            flexWrap: 'nowrap',
            gap: { xs: 0.5, sm: 0 },
            borderBottom: '1px solid var(--grey-100)',
            padding:'0px 0px 0px 16px'
          }}

        >
          {showCheckbox && (
            <Checkbox
              checked={isSelected || false}
              onChange={e => {
                e.stopPropagation();
                onSelectChange && onSelectChange(meeting.id, e.target.checked);
              }}
              onClick={e => e.stopPropagation()}
              size="small"
              sx={{ mr: 1 }}
            />
          )}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'end',
              gap: 0.5,
              // width: { xs: '100%', sm: '214px', md: '303px' },
              width: { xs: '92%', sm: '215px', md: '303px' },
              marginRight: { xs: 'auto', md: 0 },
            }}
          >
            <ClickableWrapper>
              <Typography
                variant="caption"
                color="grey.400"
                sx={{ display: 'block' }}
              >
                Meeting Title
              </Typography>

              <Tooltip title={meeting.title} arrow>
                <Typography
                  variant="body2"
                  component="div"
                  noWrap
                  fontWeight={500}
                  color="secondary.main"
                  width={'100%'}
                >
                  {meeting.title}
                </Typography>
              </Tooltip>
            
            </ClickableWrapper>
            {meeting.hasInfo && (
              <Box
                onClick={e => e.stopPropagation()}
                sx={{ alignSelf: 'flex-end', marginBottom: '-4px' }}
              >
                <Tooltip title="Parent Meeting Details" arrow>
                  <IconButton
                    size="small"
                    onClick={e => {
                      handlePopoverOpen(e, meeting);
                    }}
                  >
                    <InfoOutlinedIcon color="primary" fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            {Boolean(popoverAnchor) && <>{parentDetialsDisplay()}</>}
          </Box>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{
              mx: 2,
              height: 28,
               alignSelf: 'center', 
              display: { xs: 'none', sm: 'block' },
            }}
          />
          <Box sx={{ flexShrink: 0, ml: { xs: 'auto', sm: '0' } }}>
            <Typography variant="caption" color="grey.400">
              Start Time
            </Typography>
            <Typography variant="body2" fontWeight={500} color="text.primary">
              {meeting.startTime}
            </Typography>
          </Box>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{
              mx: 2,
              height: 28,
              alignSelf: 'center', 
              display: { xs: 'none', sm: 'block' },
            }}
          />

          <Box sx={{ flexShrink: 0 }}>
            <Typography variant="caption" color="grey.400">
              Duration
            </Typography>
            <Typography variant="body2" fontWeight={500} color="text.primary">
              {meeting.duration}
            </Typography>
          </Box>

          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{
              mx: 2,
              alignSelf: 'center', 
              height: 28,
              display: { xs: 'none', sm: 'block' },
            }}
          />
          <Box sx={{ flexShrink: 0, ml: { xs: 'auto', sm: '0' } }}>
            <Typography variant="caption" color="grey.400">
              Credits Used
            </Typography>
            <Typography variant="body2" fontWeight={500} color="text.primary">
              {meeting.creditsUsed}
            </Typography>
          </Box>
          <Box sx={{
            width: 'auto',
            minWidth: '231px', 
            flexShrink: 0,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            gap: 0.5,
            marginLeft: 'auto',
            paddingRight: '16px', 
          }}>
            {meeting.status === 'transcript' && (
              <Chip
                variant="outlined"
                size="small"
                label="Transcript Only"
                color="primary"
                sx={{
                  marginRight: { xs: '0', md: 0 },
                  display: 'flex',
                  justifyContent:'flex-end'
                }}
              />
            )}
            <Tooltip title="Restore" arrow>
              <IconButton
                size="small"
                onClick={() => {
                  setOpenRestoreDialogue(true);
                }}
                sx={{ color: 'primary.main' }}
              >
                <RestoreIconNew />
              </IconButton>
            </Tooltip>
            <Tooltip title="Permanently Delete" arrow>
              <IconButton
                size="small"
                onMouseEnter={() => {
                  setHoverDisplay(true);
                }}
                onMouseLeave={() => {
                  setHoverDisplay(false);
                }}
                onClick={() => {
                  setOpenDeleteDialogue(true);
                }}
              >
                <DeleteOutlineIcon
                  fontSize="small"
                  sx={{ color: 'error.main' }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Stack>
      </Paper>
 )}
      {isMobileView && (
        <Box sx={{ width: '100%', height: '100%', backgroundColor: 'white' }}>
          <SwipeableList threshold={0.5} type={ListType.IOS}>
            <SwipeableListItem
              trailingActions={trailingActions}
              onSwipeStart={() => {
                if (setSwipedItemId && swipedItemId !== meeting.id) {
                  setSwipedItemId(meeting.id);
                }
              }}
              key={`${meeting.id}-${swipeKey}`}
            >
              {/* Main Card Content */}
              <Box
                padding={'8px 18px'}
                onTouchStart={(e) => {
                  if (!isMobileView || !onLongPress) return;
                  touchStartTimeRef.current = Date.now();
                  longPressTimerRef.current = setTimeout(() => {
                    onLongPress(meeting.id, e);
                  }, 500); // 500ms for long-press
                }}
                onTouchEnd={(e) => {
                  if (longPressTimerRef.current) {
                    clearTimeout(longPressTimerRef.current);
                    longPressTimerRef.current = null;
                  }
                }}
                onTouchMove={(e) => {
                  // Cancel long-press if user moves finger
                  if (longPressTimerRef.current) {
                    clearTimeout(longPressTimerRef.current);
                    longPressTimerRef.current = null;
                  }
                }}
                sx={{
                  width: '100%',
                  display: 'flex',
                  height: meeting.status === 'transcript' ? '95px' : '65px',
                  borderBottom: '1px solid var(--grey-100)',
                  alignItems: 'flex-start',

                  backgroundColor: 'white',
                }}
              >
                {showCheckbox && (
                  <Checkbox
                    checked={isSelected || false}
                    onChange={e => {
                      e.stopPropagation();
                      onSelectChange && onSelectChange(meeting.id, e.target.checked);
                    }}
                    onClick={e => e.stopPropagation()}
                    size="small"
                    sx={{
                      mr: 1,
                      padding: '0px 0px'
                    }}
                  />
                )}
   <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 0.5, minWidth: 0, justifyContent: 'center' }}>
                    
                     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <ClickableWrapper>
                      <Tooltip title={meeting.title} arrow>
                        <Typography
                          variant="body2"
                          component="div"
                          noWrap
                          fontWeight={500}
                          color="secondary.main"
                          width={'100%'}
                        >
                          {meeting.title}
                        </Typography>
                      </Tooltip>

                    </ClickableWrapper>
                    {meeting.hasInfo && (
                      <Box
                        onClick={e => e.stopPropagation()}
                        sx={{ alignSelf: 'flex-end', marginBottom: '-4px' }}
                      >
                        <Tooltip title="Parent Meeting Details" arrow>
                          <IconButton
                            size="small"
                            onClick={e => {
                              handlePopoverOpen(e, meeting);
                            }}
                          >
                            <InfoOutlinedIcon color="primary" fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    )}
                    {Boolean(popoverAnchor) && <>{parentDetialsDisplay()}</>}
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5, flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
                    <Box sx={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', gap: 1 }}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Tooltip title="Start Time" arrow>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <StartTime fontSize="small" sx={{ color: 'grey.400' }} />
                            <Typography variant="body2" fontWeight={500} color="text.primary">
                              {meeting.startTime}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Box>

                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Tooltip title="Duration" arrow>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <TimerOutlinedIcon fontSize="small" sx={{ color: 'grey.400' }} />
                            <Typography variant="body2" fontWeight={500} color="text.primary">
                              {meeting.duration}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <Tooltip title="Credit Used" arrow>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <PhotoIcon fontSize="small" sx={{ color: 'grey.400' }} />
                            <Typography variant="body2" fontWeight={500} color="text.primary">
                              {meeting.creditsUsed}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Box>
                    </Box>
                    {meeting.status === 'transcript' && (
                      <Chip
                        variant="outlined"
                        size="small"
                        label="Transcript Only"
                        color="primary"
                      />
                    )}
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      sx={{
                        '.MuiList-root': {
                          '& .react-share__ShareButton': {
                            display: 'flex',
                          },
                          '& .MuiSvgIcon-root': {
                            marginRight: '4px',
                          },
                        },
                      }}
                    >
                      <MenuItem>
                        <WhatsappShareButton url={shareUrl}>
                          <WhatsAppIcon fontSize="small" />
                          <Typography variant="body2" color="text.primary">
                            WhatsApp
                          </Typography>
                        </WhatsappShareButton>
                      </MenuItem>
                      <Divider
                        component="li"
                        sx={{ borderColor: 'var(--grey-100)', m: 0 }}
                      />
                      <MenuItem>
                        <a
                          href={gmailLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={0.5}
                            sx={{ display: 'inline-flex' }}
                          >
                            <GMailIcon sx={{ fontSize: 20 }} />
                            <Typography
                              variant="body2"
                              color="text.primary"
                              lineHeight={1}
                            >
                              Gmail
                            </Typography>
                          </Stack>
                        </a>
                      </MenuItem>
                    </Menu>
                    {/* <Tooltip title="Restore" arrow>
              <IconButton
                size="small"
                onClick={() => {
                  setOpenRestoreDialogue(true);
                }}
                sx={{ color: 'primary.main' }}
              >
                <RestoreIconNew />
              </IconButton>
            </Tooltip> */}
                    {/* <Tooltip title="Permanently Delete" arrow>
              <IconButton
                size="small"
                onMouseEnter={() => {
                  setHoverDisplay(true);
                }}
                onMouseLeave={() => {
                  setHoverDisplay(false);
                }}
                onClick={() => {
                  setOpenDeleteDialogue(true);
                }}
              >
                <DeleteOutlineIcon
                  fontSize="small"
                  sx={{ color: 'error.main' }}
                />
              </IconButton>
            </Tooltip> */}
                  </Box>
                </Box>
              </Box>
            </SwipeableListItem>
          </SwipeableList>
        </Box>
      )}

        <Dialog
          open={openRestoreDialogue}
          onClose={() => setOpenRestoreDialogue(false)}
          maxWidth="xs"
          fullWidth
        >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Restore Meeting?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            <strong>{meeting?.title}</strong> will be restored and moved back to
            your meeting history.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRestoreDialogue(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              handleRestore(meeting?.id);
              setOpenRestoreDialogue(false);
            }}
          >
            RESTORE
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteDialogue}
        onClose={() => setOpenDeleteDialogue(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Permanently Delete Meeting?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            <strong>{meeting?.title}</strong> will be permanently deleted. This
            action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialogue(false)}>
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={() => {
              handlePermanentDelete(meeting?.id);
              setOpenDeleteDialogue(false);
            }}
          >
            DELETE PERMANENTLY
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

// --- MAIN COMPONENT ---
export default function DeletedMeetings(props) {
  // React Router hooks
  const navigate = useNavigate();
  const location = useLocation();

  // App Context for shared state
  const {
    details,
    setDetails,
    loading,
    setLoading,
    formatTime,
    formatDuration,
    formatDateTime,
  } = useAppContext();

  // Determine current route info
  const currentPath = location.pathname;
  const isOnBinRoute = currentPath === ROUTES.BIN;

  const [swipedItemId, setSwipedItemId] = useState(null);
  const [containerHeight, setContainerHeight] = useState(500);
  const listWrapperRef = useRef(null);

  useEffect(() => {
     const updateHeight = () => {
        if (listWrapperRef.current) {
           setContainerHeight(listWrapperRef.current.clientHeight);
        }
     };
     updateHeight();
     window.addEventListener('resize', updateHeight);
     const observer = new ResizeObserver(updateHeight);
     if (listWrapperRef.current) observer.observe(listWrapperRef.current);
     return () => {
        window.removeEventListener('resize', updateHeight);
        observer.disconnect();
     };
  }, []);

  const transScriptSession = useSelector(
    state => state.sessionDetail.transScriptSession
  );
  const dispatch = useDispatch();
  const [triggerMeetingHistoryCall, setTriggerMeetingHistoryCall] =
    useState(false);
  const [meetingHistoryData, setMeetingHistoryData] = useState({ apiData: [] });
  const currentDate = dayjs();
  const [dataExists, setDataExists] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [transcriptOnlyToggle, setTranscriptOnlyToggle] = useState(false);
  const [selectedMeetings, setSelectedMeetings] = useState(new Set());
  const [openBulkDeleteDialog, setOpenBulkDeleteDialog] = useState(false);
  const [openBulkRestoreDialog, setOpenBulkRestoreDialog] = useState(false);

  const [dateValue, setDateValue] = useState([
    dayjs(currentDate.subtract(365, 'day')),
    currentDate,
  ]);

  const groupedMeetingData = useMemo(() => {
    var data = meetingHistoryData.apiData;
    if (meetingHistoryData.hasOwnProperty('searchResult')) {
      data = meetingHistoryData.searchResult;
    }
    if (transcriptOnlyToggle) {
      data = data.filter(ele => ele.status === 'transcript');
    }
    if (data && typeof data === 'object' && data.length > 0) {
      return groupMeetings(data);
    } else {
      return [];
    }
  }, [meetingHistoryData, transcriptOnlyToggle]);

  const [expandedGroups, setExpandedGroups] = useState(() => {
    const initial = {};
    groupedMeetingData.forEach(group => {
      initial[group.dateLabel] = true;
    });
    return initial;
  });

  const expandAll = () => {
    const allExpanded = {};
    groupedMeetingData.forEach(group => {
      allExpanded[group.dateLabel] = true;
    });
    setExpandedGroups(allExpanded);
    listRef.current?.resetAfterIndex(0);
  };

  useEffect(() => {
    expandAll();
  }, [groupedMeetingData]);

  const listRef = useRef();

  useEffect(() => {
    if (isOnBinRoute && transScriptSession) {
      fetchDeletedMeetings(dateValue);
    }
    setTranscriptOnlyToggle(false);
    setSelectedMeetings(new Set());
  }, [isOnBinRoute, transScriptSession]);

  useEffect(() => {
    if (transScriptSession && triggerMeetingHistoryCall) {
      fetchDeletedMeetings(dateValue);
    }
  }, [triggerMeetingHistoryCall]);

  const fetchDeletedMeetings = async dateRange => {
    // Fetch deleted meetings - using deleted=true query parameter
    // In future, this can be updated to use a different endpoint or parameter
    const url = `${API_URL}/api/history?start_date=${dateRange[0].format(
      'DD-MM-YYYY'
    )}&end_date=${dateRange[1].format('DD-MM-YYYY')}&include_deleted=true`;
    setLoading(true);
    try {
      const value = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
        },
      });
      // Filter only deleted meetings
      // Backend should return is_deleted: true for soft-deleted meetings
      // Or deleted_at: timestamp (non-null) for deleted meetings
      const deletedRecords = (value.data || []).filter(record => {
        // Primary check: is_deleted field (boolean)
        if (record?.is_deleted === true) {
          return true;
        }
        // Secondary check: deleted_at field (timestamp - non-null means deleted)
        if (record?.deleted_at !== null && record?.deleted_at !== undefined) {
          return true;
        }
        // Fallback checks for other possible field names
        if (record?.is_soft_deleted === true || record?.deleted === true) {
          return true;
        }
        return false;
      });

      if (deletedRecords.length === 0) {
        setMeetingHistoryData({ apiData: [] });
        setDataExists(false);
        return;
      }

      setDataExists(true);
      var data = deletedRecords.map(ele => {
        var dateTime = formatDateTime(ele.date);
        var obj = {
          id: ele.id,
          isRecording: false,
          title: ele.title,
          duration: formatDuration(ele.duration),
          startTime: dateTime[1],
          dateLabel: dateTime[0],
          creditsUsed: ele.credits_used,
          hasInfo: Boolean(ele.parent_recording_id),
          status: Boolean(ele.has_mom) ? 'full' : 'transcript',
          infoDetails: {},
          parentRecordingId: ele.parent_recording_id,
        };
        return obj;
      });
      setMeetingHistoryData({ apiData: data });
      setTriggerMeetingHistoryCall(false);
      setSelectedMeetings(new Set());
    } catch (err) {
      dispatch(
        openSnackbar(
          'error',
          'Something went wrong while fetching deleted meetings list.'
        )
      );
      // Error while fetching deleted meetings
      setTriggerMeetingHistoryCall(false);
    } finally {
      setLoading(false);
      setHasFetched(true);
    }
  };

  const handleSearch = value => {
    var data = meetingHistoryData.apiData.filter(row => {
      var search = row.title.toLowerCase();
      return search.includes(value.toLowerCase());
    });
    setMeetingHistoryData(prev => ({ ...prev, ...{ searchResult: data } }));
    if (!value || value.trim() === '') {
      setSelectedMeetings(new Set());
    }
  };

  const handleRestore = async meetingId => {
    // Restore API - call delete API with recover=true in payload
    const url = `${API_URL}/api/history`;
    setLoading(true);
    try {
      const value = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
          'Content-Type': 'application/json',
        },
        data: {
          recording_ids: [meetingId],
          recover: true,
        },
      });
      dispatch(openSnackbar('success', 'Meeting restored successfully.'));
      setTriggerMeetingHistoryCall(true);
    } catch (err) {
      // Error while restoring meeting
      dispatch(
        openSnackbar('error', 'Something went wrong while restoring meeting.')
      );
      setTriggerMeetingHistoryCall(true);
    } finally {
      setLoading(false);
    }
  };

  const handlePermanentDelete = async meetingId => {
    // Permanent delete API - pass recording_ids and recover=false in payload
    const url = `${API_URL}/api/history`;
    setLoading(true);
    try {
      const value = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
          'Content-Type': 'application/json',
        },
        data: {
          recording_ids: [meetingId],
          recover: false,
        },
      });
      dispatch(openSnackbar('success', 'Meeting permanently deleted.'));
      setTriggerMeetingHistoryCall(true);
    } catch (err) {
      // Error while permanently deleting meeting
      dispatch(
        openSnackbar(
          'error',
          'Something went wrong while permanently deleting meeting.'
        )
      );
      setTriggerMeetingHistoryCall(true);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkRestore = async () => {
    const meetingIds = Array.from(selectedMeetings);
    if (meetingIds.length === 0) return;

    setLoading(true);
    try {
      // Single API call with all recording IDs
      await axios.delete(`${API_URL}/api/history`, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
          'Content-Type': 'application/json',
        },
        data: {
          recording_ids: meetingIds,
          recover: true,
        },
      });

      dispatch(
        openSnackbar(
          'success',
          `${meetingIds.length} meeting(s) restored successfully.`
        )
      );
      setSelectedMeetings(new Set());
      setOpenBulkRestoreDialog(false);
      setTriggerMeetingHistoryCall(true);
    } catch (err) {
      dispatch(
        openSnackbar('error', 'Something went wrong while restoring meetings.')
      );
      setTriggerMeetingHistoryCall(true);
    } finally {
      setLoading(false);
    }
  };

  const handleBulkPermanentDelete = async () => {
    const meetingIds = Array.from(selectedMeetings);
    if (meetingIds.length === 0) return;

    setLoading(true);
    try {
      // Single API call with all recording IDs
      await axios.delete(`${API_URL}/api/history`, {
        headers: {
          Authorization: `Bearer ${transScriptSession}`,
          'Content-Type': 'application/json',
        },
        data: {
          recording_ids: meetingIds,
          recover: false,
        },
      });

      dispatch(
        openSnackbar(
          'success',
          `${meetingIds.length} meeting(s) permanently deleted successfully.`
        )
      );
      setSelectedMeetings(new Set());
      setOpenBulkDeleteDialog(false);
      setTriggerMeetingHistoryCall(true);
    } catch (err) {
      // Error while permanently deleting meetings
      dispatch(
        openSnackbar(
          'error',
          'Something went wrong while permanently deleting meetings.'
        )
      );
      setTriggerMeetingHistoryCall(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectMeeting = useCallback((meetingId, isSelected) => {
    setSelectedMeetings(prev => {
      const newSet = new Set(prev);
      if (isSelected) {
        newSet.add(meetingId);
      } else {
        newSet.delete(meetingId);
      }
      return newSet;
    });
  }, []);

  // Handle long-press to enable selection mode and select item
  const handleLongPress = useCallback((meetingId, event) => {
    const isMobileView = isMobile || isTablet;
    if (!isMobileView) return;
    
    event?.preventDefault?.();
    event?.stopPropagation?.();
    
    // Select the item
    handleSelectMeeting(meetingId, true);
    
    // Provide haptic feedback if available
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
  }, [handleSelectMeeting]);

  const handleSelectAll = (meetings, isSelected) => {
    setSelectedMeetings(prev => {
      const newSet = new Set(prev);
      if (isSelected) {
        meetings.forEach(meeting => {
          newSet.add(meeting.id);
        });
      } else {
        meetings.forEach(meeting => {
          newSet.delete(meeting.id);
        });
      }
      return newSet;
    });
  };

  const getAllMeetings = useMemo(() => {
    return groupedMeetingData.flatMap(group => group.meetings);
  }, [groupedMeetingData]);

  const allMeetingsSelected =
    getAllMeetings.length > 0 &&
    getAllMeetings.every(meeting => selectedMeetings.has(meeting.id));

  const someMeetingsSelected =
    getAllMeetings.some(meeting => selectedMeetings.has(meeting.id)) &&
    !allMeetingsSelected;

  const virtualRows = useMemo(() => {
    return groupedMeetingData.flatMap(({ dateLabel, meetings }) => {
      const rows = [{ type: 'header', dateLabel, meetings }];
      if (expandedGroups[dateLabel]) {
        rows.push(
          ...meetings.map(meeting => ({
            type: 'item',
            dateLabel,
            meeting,
          }))
        );
      }
      return rows;
    });
  }, [groupedMeetingData, expandedGroups]);

  const Row = ({ index, style, data }) => {
    const {
      data: listData,
      selectedMeetings,
      handleSelectMeeting,
      handleSelectAll,
       swipedItemId,     
      setSwipedItemId,
    } = data;

    const row = listData[index];

    if (row.type === 'header') {
      const isExpanded = expandedGroups[row.dateLabel];
      const groupMeetings = row.meetings || [];
      const selectedSet = selectedMeetings || new Set();
      const groupSelectedCount = groupMeetings.filter(m =>
        selectedSet.has(m.id)
      ).length;
      const allGroupSelected =
        groupMeetings.length > 0 && groupSelectedCount === groupMeetings.length;
      const someGroupSelected =
        groupSelectedCount > 0 && groupSelectedCount < groupMeetings.length;

      return (
        <div style={style}>
        <Box             
            sx={{
              // minWidth: `${MIN_ROW_WIDTH}px`, // ADDED: Forces alignment with content
              minWidth: isMobileView ? '100%' : `${MIN_ROW_WIDTH}px`,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              // px: 2,
              paddingX: isMobile ? '8px' : 2,
              gap: 1,
              background: 'var(--grey-50)',
              borderTop: '1px solid var(--grey-100)',
              borderBottom: '1px solid var(--grey-100)',
              cursor: 'pointer',

            }}>
            {groupMeetings.length > 0 && (
              <Checkbox
                checked={allGroupSelected}
                indeterminate={someGroupSelected}
                onChange={e => {
                  e.stopPropagation();
                  handleSelectAll(groupMeetings, e.target.checked);
                }}
                onClick={e => e.stopPropagation()}
                size="small"
              />
            )}
            <Typography
              variant="caption"
              fontWeight={500}
              onClick={() => {
                setExpandedGroups(prev => {
                  const updated = {
                    ...prev,
                    [row.dateLabel]: !prev[row.dateLabel],
                  };

                  setTimeout(() => {
                    listRef.current?.resetAfterIndex(0);
                  }, 0);

                  return updated;
                });
              }}
              sx={{ flex: 1 }}
            >
              {row.dateLabel}
              {groupMeetings.length > 0 && groupSelectedCount > 0 && (
                <Typography
                  component="span"
                  variant="caption"
                  sx={{ ml: 1, color: 'text.secondary' }}
                >
                  ({groupSelectedCount})
                </Typography>
              )}
            </Typography>
            <Tooltip title={isExpanded ? 'Collapse' : 'Expand'} arrow>
              <IconButton
                size="small"
                onClick={e => {
                  e.stopPropagation();
                  setExpandedGroups(prev => {
                    const updated = {
                      ...prev,
                      [row.dateLabel]: !prev[row.dateLabel],
                    };

                    setTimeout(() => {
                      listRef.current?.resetAfterIndex(0);
                    }, 0);

                    return updated;
                  });
                }}
              >
                <ExpandMoreIcon
                  sx={{
                    transform: expandedGroups[row.dateLabel]
                      ? 'rotate(0deg)'
                      : 'rotate(-90deg)',
                    transition: 'transform 0.2s ease-in-out',
                  }}
                />
              </IconButton>
            </Tooltip>
          {/* </Box> */}
        </Box>
        </div>
      );
    }

    return (
      <div
        style={style}
        className="meeting-item-test">
        {!isMobileView ? (
          <Collapse in={true} timeout="auto" sx={{ width: '100%' }}>
            <MeetingItem
              meeting={row.meeting}
              handlePermanentDelete={handlePermanentDelete}
              handleRestore={handleRestore}
              props={props}
              setLoading={setLoading}
              setDetails={setDetails}
              navigate={navigate}
              dispatch={dispatch}
              meetingHistoryData={meetingHistoryData}
              isSelected={
                selectedMeetings ? selectedMeetings.has(row.meeting.id) : false
              }
              onSelectChange={handleSelectMeeting}
              showCheckbox={true}
              setTriggerMeetingHistoryCall={setTriggerMeetingHistoryCall}
            />
          </Collapse>
        ) : (
          <MeetingItem
            meeting={row.meeting}
            handlePermanentDelete={handlePermanentDelete}
            handleRestore={handleRestore}
            props={props}
            setLoading={setLoading}
            setDetails={setDetails}
            navigate={navigate}
            dispatch={dispatch}
            meetingHistoryData={meetingHistoryData}
            isSelected={
              selectedMeetings ? selectedMeetings.has(row.meeting.id) : false
            }
            onSelectChange={handleSelectMeeting}
            showCheckbox={true}
            onLongPress={handleLongPress}
            swipedItemId={swipedItemId}
            setSwipedItemId={setSwipedItemId}
            setTriggerMeetingHistoryCall={setTriggerMeetingHistoryCall}
          />
        )}
      </div>
    );
  };

    const isMobileView = isMobile || isTablet;
  const getItemSize = index => {
    const row = virtualRows[index];
    if (row.type === 'header') return 40;
    if (isMobileView) {
      return row.meeting?.status === 'transcript' ? 95 : 65; 
    }
    return 60;
  };

  const handleDateChange = e => {
    setDateValue(e);
    fetchDeletedMeetings(e);
  };
  // const getItemSize = index => {
  //   const row = virtualRows[index];
  //   const currentWidth = window.innerWidth;

  //   if (row.type === 'header') {
  //     return 40;
  //   } else {
  //     if (currentWidth < 600) {
  //       return 140;
  //     } else if (currentWidth < 960) {
  //       return 80;
  //     } else {
  //       return 60;
  //     }
  //   }
  // };

  useEffect(() => {
    setSelectedMeetings(new Set());
  }, [transcriptOnlyToggle]);

  return (
    <Box
      sx={{
        width: '100%',
        height: {
          // xs: ['calc(100vh - 116px)', 'calc(100dvh - 116px)'],
          // sm: ['calc(100vh - 145px)', 'calc(100dvh - 145px)'],
        },
        overflow: 'hidden',
      }}
    >
      <Stack height={'100%'}>
        <Box
          sx={{
            display: { xs: 'flex', sm: 'flex', md: 'none' },
            alignItems: 'center',
            gap: 1,
            padding:'4px 8px',
            backgroundColor: 'var(--grey-0)',
            borderBottom: '1px solid var(--grey-100)',
          }}
        >
          <IconButton
            size="small"
            sx={{ color: 'text.primary', p: 0.5 }}
            onClick={() => {
              // In mobile view, back from Recycle Bin should always go to history
              navigate(ROUTES.HISTORY);
            }}
          >
            <KeyboardBackspaceIcon fontSize="small" />
          </IconButton>
          <Typography variant="subtitle1" fontWeight={600} color="text.primary">
            Recycle bin
          </Typography>
        </Box>

        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 12,
            backgroundColor: 'var(--grey-0)',
            borderBottom: '1px solid var(--grey-100)',
          }}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            sx={{
                 m: { xs: 0, md: 3 },
                mb: { xs: 0, md: 2 },
                px: 2,
                py: 0.5,
              gap: { xs: 1, md: 2 },
              background: { xs: 'transparent', md: 'var(--grey-0)' },
              border: '1px solid var(--grey-100)',
              borderRadius: { xs: 0, md: '10px' },
              // borderBottom:  '1px solid var(--grey-100)' ,
            }}
          >
            <TextField
              fullWidth
              variant="standard"
              placeholder="Search deleted meetings here..."
              onChange={e => {
                const value = e.target.value.trim() || '';
                if (value && value.length > 0) {
                  handleSearch(value);
                } else {
                  setMeetingHistoryData({
                    apiData: meetingHistoryData.apiData,
                  });
                }
              }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                },
              }}
              type="search"
              size="small"
              sx={{
                '& .MuiInputBase-input': {
                  padding: 0,
                },
                '& .MuiInput-underline:before': {
                  borderBottom: 'none',
                },
                '& .MuiInput-underline:after': {
                  borderBottom: 'none',
                },
                '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
                  borderBottom: 'none',
                },
              }}
            />
            <Box display={'flex'} alignItems={'center'} gap={1}>
              <Tooltip title="Show Transcript Only" arrow>
                <Switch
                  checked={transcriptOnlyToggle}
                  onChange={e => {
                    setTranscriptOnlyToggle(e.target.checked);
                  }}
                  size="small"
                />
              </Tooltip>
              <Tooltip title="Refresh" arrow>
                <IconButton size="small">
                  <RefreshIcon
                    onClick={() => {
                      setTriggerMeetingHistoryCall(true);
                    }}
                  />
                </IconButton>
              </Tooltip>
              <CustomDateRangePicker
                value={dateValue}
                setDateRangeValue={handleDateChange}
              />
            </Box>
          </Box>
          {getAllMeetings.length > 0 && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                // px: 2,
                paddingX: isMobile ? '8px' : 2,
                py: isMobile ? 0 : 1,
                // py: 1,
                borderBottom: '1px solid var(--grey-100)',
                backgroundColor: 'var(--grey-0)',
              }}
            >
              <Checkbox
                checked={allMeetingsSelected}
                indeterminate={someMeetingsSelected}
                onChange={e => {
                  handleSelectAll(getAllMeetings, e.target.checked);
                }}
                size="small"
              />
              <Typography variant="body2" color="text.primary">
                Select All ({selectedMeetings.size})
              </Typography>
              {selectedMeetings.size > 0 && (
                <>
                  <Box sx={{ ml: 'auto', display: 'flex', gap: 0.5 }}>
                    <Tooltip title="Restore Selected" arrow>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setOpenBulkRestoreDialog(true);
                        }}
                        sx={{ color: 'primary.main' }}
                      >
                        <RestoreIconNew />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Permanently Delete Selected" arrow>
                      <IconButton
                        size="small"
                        onClick={() => {
                          setOpenBulkDeleteDialog(true);
                        }}
                        sx={{ color: 'error.main' }}
                      >
                        <DeleteOutlineIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </>
              )}
            </Box>
          )}
        </Box>

        {dataExists ? (
          <Box
            sx={{
              height: '100%',
              // overflowY: 'auto',
               overflowX: 'auto',
            }}
          >
            <Stack sx={{ height: '100%', flex: '1 1 auto' }}>
              <List
                ref={listRef}
                height={window.innerHeight - 64}
                itemCount={virtualRows.length}
                itemSize={getItemSize}
                width="100%"
                itemData={{
                  data: virtualRows,
                  selectedMeetings,
                  handleSelectMeeting,
                  handleSelectAll,
                }}
              >
                {Row}
              </List>
            </Stack>
          </Box>
        ) : (
          !loading && hasFetched && (
            <Box
              sx={{
                justifyContent: 'center',
                alignContent: 'center',
                alignItems: 'center',
                height: '100%',
                display: 'flex',
                width: '100%',
              }}
            >
              <img
                src={deletedrecordsfound}
                style={{ minWidth: '100px', maxWidth: '60%' }}
              />
            </Box>
          )
        )}
      </Stack>

      <Dialog
        open={openBulkRestoreDialog}
        onClose={() => setOpenBulkRestoreDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Restore Selected Meetings?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            {selectedMeetings.size === 1 ? (
              <>
                1 meeting will be restored and moved back to your meeting
                history.
              </>
            ) : (
              <>
                {selectedMeetings.size} meetings will be restored and moved back
                to your meeting history.
              </>
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenBulkRestoreDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={handleBulkRestore}
          >
            RESTORE
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openBulkDeleteDialog}
        onClose={() => setOpenBulkDeleteDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>
          <Typography
            variant="subtitle1"
            component={'span'}
            color="text.primary"
          >
            Permanently Delete Selected Meetings?
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="text.primary">
            {selectedMeetings.size === 1 ? (
              <>
                1 meeting will be permanently deleted. This action cannot be
                undone.
              </>
            ) : (
              <>
                {selectedMeetings.size} meetings will be permanently deleted.
                This action cannot be undone.
              </>
            )}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenBulkDeleteDialog(false);
            }}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={handleBulkPermanentDelete}
          >
            DELETE PERMANENTLY
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
